import { Line, Text } from '@react-three/drei';
import { invalidate } from '@react-three/fiber';
import { Suspense } from 'react';
import { Vector3 } from 'three';

import { useCreateEdgeDimensioning } from 'app/modules/wallforming/components/scenes/objects/dimensions/hooks/useCreateEdgeDimensioning';
import { DIMENSION_COLOR } from 'shared/constants';

interface EdgeDimensionProps {
    mid: Vector3;
    dir: Vector3;
    selectedPoiIndex: number;
}

export const EdgeDimension = ({ mid, dir, selectedPoiIndex }: EdgeDimensionProps) => {
    const result = useCreateEdgeDimensioning({
        selectedPoiIndex,
        mid,
        dir
    });

    if (!result || !result?.edges || result?.edges?.length === 0) {
        return null;
    }

    return (
        <>
            {/* Height dimension */}
            {result.edges.map((edge) => (
                <Line
                    key={edge.id}
                    color={DIMENSION_COLOR}
                    dashSize={0.05}
                    gapSize={0.02}
                    lineWidth={2}
                    points={[edge.start, edge.end]}
                    renderOrder={120}
                    dashed
                />
            ))}

            {/* Angle dimension */}
            <Line
                color={DIMENSION_COLOR}
                lineWidth={2}
                points={[result.faceLines[0], result.faceLines[1]]}
                renderOrder={121}
            />
            <Line
                color={DIMENSION_COLOR}
                lineWidth={2}
                points={[result.faceLines[2], result.faceLines[3]]}
                renderOrder={121}
            />
            <Line color={DIMENSION_COLOR} lineWidth={2} points={result.angleArc} renderOrder={121} />

            {/* Dimension labels */}
            <Suspense>
                {result.texts.map((t) => (
                    <Text
                        key={t.id}
                        anchorX="center"
                        anchorY="middle"
                        color={t.color}
                        fontSize={t.fontSize}
                        position={t.position.toArray()}
                        rotation={result.euler?.toArray()}
                        onSync={() => invalidate()}
                    >
                        {t.text}
                    </Text>
                ))}
            </Suspense>
        </>
    );
};
